export default __webpack_public_path__ + "static/media/Lovkash_garg_Resume.2ad230dc.pdf";